export default __webpack_public_path__ + "static/media/banner-maths.1e69f235.jpeg";